import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Unread = withDefaultIconProps(
  {
    height: 24,
    width: 24,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} fill="none" viewBox="0 0 24 24">
      <Path
        d="M18.544 16.61v-5.258a.611.611 0 00-1.222 0v5.258a1.18 1.18 0 01-1.178 1.179H7.39A1.18 1.18 0 016.21 16.61V7.856c0-.65.529-1.178 1.179-1.178h5.258a.611.611 0 000-1.222H7.39a2.404 2.404 0 00-2.401 2.4v8.754c0 1.324 1.077 2.401 2.4 2.401h8.755c1.323 0 2.4-1.077 2.4-2.4zM17.933 9.144a3.078 3.078 0 100-6.155 3.078 3.078 0 000 6.155z"
        fill={color}
      />
    </Svg>
  ),
);
